import '../styles/components/CategoryCard.scss'

const CategoryCard = ({ name, image, onClick, categoryId }) => {
    return(
        <div className="category-card" onClick={() => onClick && onClick(categoryId)}>
            <img src={image} alt={name} />
            <h3> {name} </h3> 
        </div>
    )
}

export default CategoryCard;